import React, { PropsWithChildren } from 'react'

import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import SummaryNavigation, { ISummaryNavigationProps } from '@components/UI/SummaryNavigation'
import { IInfluencerIdentityIdContextProps } from '@context/InfluencerIdentityId'
import { EventTrackingNames } from '@enums'
import { withContextInfluencerIdentityId, withSubmissionListFilter } from '@hocs'
import { IApplicationState } from '@store'
import { selectCampaignId, selectSubmissionId } from '@store/router'
import {
  selectInfluencerIdentityNextSubmissionId,
  selectInfluencerIdentityPrevSubmissionId,
} from '@store/submissions'
import { buildSubmissionUrlById } from '@utils/urls'

export interface IInternalProps
  extends ISummaryNavigationProps,
    IInfluencerIdentityIdContextProps {}

export const SubmissionSummaryNavigationByInfluencerIdentityId: React.FC<
  PropsWithChildren<IInternalProps>
> = ({ children, contextInfluencerIdentityId }) => {
  const match = useRouteMatch()
  const campaignId = selectCampaignId(match) as number
  const submissionId = selectSubmissionId(match) as number

  const prevSubmissionId = useSelector((state: IApplicationState) =>
    selectInfluencerIdentityPrevSubmissionId(
      state,
      campaignId,
      contextInfluencerIdentityId,
      submissionId,
    ),
  )
  const nextSubmissionId = useSelector((state: IApplicationState) =>
    selectInfluencerIdentityNextSubmissionId(
      state,
      campaignId,
      contextInfluencerIdentityId,
      submissionId,
    ),
  )

  const prevLink = buildSubmissionUrlById(campaignId, prevSubmissionId) as string | undefined
  const nextLink = buildSubmissionUrlById(campaignId, nextSubmissionId) as string | undefined

  return (
    <SummaryNavigation
      prevLink={prevLink}
      nextLink={nextLink}
      currentId={submissionId}
      nextTrackingProps={{
        campaignId,
        eventName: EventTrackingNames.ViewSubmission,
        submissionId: nextSubmissionId,
      }}
      prevTrackingProps={{
        campaignId,
        eventName: EventTrackingNames.ViewSubmission,
        submissionId: prevSubmissionId,
      }}
      loadingMore={false}
    >
      {children}
    </SummaryNavigation>
  )
}

export default withSubmissionListFilter(
  withContextInfluencerIdentityId(SubmissionSummaryNavigationByInfluencerIdentityId),
)
